import "./App.css";
import { links } from "./links";

function App() {
  return (
    <div className="container">
      {links.map((link, index) => (
        <a
          key={index}
          className="content"
          href={link.href}
          style={{ "--hover-color": link.color } as React.CSSProperties}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.label}
          {index < links.length - 1 ? ", " : "."}
        </a>
      ))}
    </div>
  );
}

export default App;
